module.exports = __webpack_public_path__ + "img/2-1.2958d62c.png";